import React from 'react';

import { RoomType } from '$/GraphQL/schema/types';
import { DisabledCCIcon, EnabledCCIcon } from '$/images/FontAwesomeIcons';
import { withWebinarPlayerContext } from '../context';
import { css } from '@emotion/react';
import tw from 'twin.macro';

export const CCPlayerButton: React.FC<{
  className?: string;
}> = withWebinarPlayerContext(
  ['enabledCC', 'setEnabledCC', 'player', 'loaded', 'currentRoom', 'ewebinar'],
  'CCPlayerButton'
)(({ className, context }) => {
  const { enabledCC, setEnabledCC, player, loaded, currentRoom, ewebinar } = context;
  const canShow = currentRoom.type === RoomType.Presentation;

  React.useEffect(() => {
    if (!player || !loaded) return;

    if (enabledCC && ewebinar.vimeoTextTrackId) {
      const lang = ewebinar.viewerRoomSettings?.language?.toLowerCase() ?? 'en';
      try {
        player?.enableTextTrack(lang);
      } catch (e) {
        const error = e as Error;

        console.error('ERROR Enabling CC ', { lang, error });
        player?.disableTextTrack();
      }
    } else {
      player?.disableTextTrack();
    }
  }, [player, loaded, enabledCC, ewebinar.vimeoTextTrackId, ewebinar.viewerRoomSettings?.language]);

  if (!ewebinar.vimeoTextTrackId) return null;

  return (
    <div
      className={`
        ${!canShow && 'hidden'} 
        ${className} 
        CCPlayerButton control
        cursor-pointer
      `}
      css={css`
        ${!enabledCC ? tw`opacity-70` : undefined}
        -webkit-tap-highlight-color: transparent;
        > svg {
          height: 1.25rem;
        }
      `}
      onClick={(): void => setEnabledCC(!enabledCC)}
    >
      {enabledCC ? <EnabledCCIcon /> : <DisabledCCIcon />}
    </div>
  );
});
